/**
 * Karrier Smart Component
 * @author Erik Banhalmi 2017.06.27.
 */

export const CareerComponent = {
	transclude: true,
	templateUrl: 'career.html',
	controller: class CareerComponent {
		constructor(CareerHandlerService, notificationService) {
			'ngInject';
			this.CareerHandlerService = CareerHandlerService;
			this.notificationService = notificationService;
		}

		$onInit() {

			this.CareerHandlerService.getPageInitData().then(
				(response) => {
					this.careerPageData = response.data;
				},
				() => {
					this.notificationService.showError({
						message: 'technicalError'
					});
				}
			);
		}

		clickOnMore(title, $event) {
			$event.preventDefault();
			$event.stopPropagation();
			let link = angular.element($event.target).attr('href') || angular.element($event.currentTarget).attr('data-link');
			setTimeout(() => {
				window.location.href = link;
			}, 500);
		}
	}
};
